export function pushDataLayer(event: string, other: object) {
    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push({
      event,
      ...other
    });
}
